import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TopFilterReorder = () => {
  const location = useLocation(); // Watch URL changes

  useEffect(() => {
    const moveNode = () => {
      const referenceNode = document.getElementById("plp-filters-grid-item");
      const targetNode = document.getElementById("top-filter-selection");

      if (referenceNode && targetNode && referenceNode.parentNode) {
        referenceNode.parentNode.insertBefore(targetNode, referenceNode.nextSibling);
        return true;
      }
      return false;
    };

    // Try immediately
    if (moveNode()) return;

    // Observe DOM changes (React/MUI async render safe)
    const observer = new MutationObserver(() => {
      if (moveNode()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [location.pathname]); // <-- re-run effect on URL change

  return null;
};

export default TopFilterReorder;
